/**
 * Authentication layout — a centred card for the sign-in flows.
 */

import { Outlet, Link, Navigate, useLocation } from 'react-router-dom';
import { config } from '../config/appConfig.js';
import { useAuth } from '../providers/AuthProvider.jsx';
import { Logo } from '../components/brand/Logo.jsx';
import { ThemeToggle } from '../components/ui/ThemeToggle.jsx';
import { PageLoader } from '../components/feedback/PageLoader.jsx';
import styles from './AuthLayout.module.css';

export function AuthLayout() {
  const { isAuthenticated, initialized } = useAuth();
  const location = useLocation();

  if (!initialized) return <PageLoader />;

  // A signed-in user has no reason to see the login form. Password reset and
  // email verification are still reachable, since both are used while signed in.
  const alwaysAvailable = ['/reset-password', '/verify-email'];
  if (isAuthenticated && !alwaysAvailable.includes(location.pathname)) {
    const destination = location.state?.from?.pathname ?? '/app';
    return <Navigate to={destination} replace />;
  }

  return (
    <div className={styles.shell}>
      <header className={styles.header}>
        <Link to="/" aria-label={`${config.appName} home`} className={styles.logoLink}>
          <Logo />
        </Link>
        <ThemeToggle />
      </header>

      <main className={styles.main}>
        <div className={styles.card}>
          <Outlet />
        </div>

        <p className={styles.legal}>
          By continuing you agree to the <Link to="/terms">Terms of Service</Link> and{' '}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </main>
    </div>
  );
}
